import PropTypes from 'prop-types';
import { Modal as MuiModal, Box } from '@mui/material';
import './Modal.scss';

export const Modal = (props) => {
  const { children, open, extendClass = '', closeModalHandler } = props;
  const classes = ['mui-modal-content', extendClass].join(' ');

  return (
    <MuiModal
      open={open}
      onClose={closeModalHandler}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      disableScrollLock
    >
      <Box className={classes}>{children}</Box>
    </MuiModal>
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  open: PropTypes.bool,
  closeModalHandler: PropTypes.func,
  extendClass: PropTypes.string,
};
